import * as React from "react";
import config from "../config/config";

import {Link} from "react-router-dom";

import useOverviewData from "../hooks/useOverviewData";
import Overview from "../components/Overview";
import OverviewTable from "../components/OverviewTable";
import t from "../hooks/useTranslation";

import './Clients.css';

const INITIAL_BRICKS_DATA = [
    {
        label: 'Celkem klientů',
        isLoading: true,
        dataKey: 'clientCount'
    },
    {
        label: 'Nevím co sem dát',
        isLoading: true,
        dataKey: 'clientCount'
    },
    {
        label: 'Ani sem',
        isLoading: true,
        dataKey: 'clientCount'
    },
    {
        label: 'A ani sem',
        isLoading: true,
        dataKey: 'clientCount'
    }
];

function Clients() {
    const {isLoading, error, response, bricksData} = useOverviewData('/api/client/dashboard', INITIAL_BRICKS_DATA);

    const columns = [
        {
            key: 'name',
            title: t('client'),
            linkRenderer: ({_id, name}) => ({
                route: config.routeMap.getClientDetail(_id),
                label: name
            })
        },
        {
            key: 'address',
            title: t('city'),
            valueRenderer: ({address}) => address.city
        },
        {
            key: 'address',
            title: t('street'),
            valueRenderer: ({address}) => `${address.street} ${address.houseNumber}`
        },
        {
            key: 'address',
            title: t('zip'),
            valueRenderer: ({address}) => address.zip
        },
        {
            key: 'visitedCount',
            title: t('visitedCount'),
            valueRenderer: ({visitedCount}) => visitedCount || 0
        }
    ];

    const actions = [
        {
            component: ({_id}) => <Link className="action" to={config.routeMap.getClientDetail(_id)}>
                {t('detail')}
            </Link>
        }
    ];

    const tableActions = [
        {
            component: <Link to={config.routeMap.addClient}>{t('newClient')}</Link>
        }
    ];

    return (
        <div className="Clients">
            <Overview
                isLoading={isLoading}
                introduction={t('introductionText')}
                title={t('clientsAdministration')}
                bricks={bricksData}
                error={error}
            >
                <OverviewTable actions={actions} title={t('clientsList')} columns={columns}
                               rows={response?.overviewData}
                               isLoading={isLoading} error={error} tableActions={tableActions}/>
            </Overview>
        </div>
    );
}

export default Clients;
